/**
 * FileActionData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { FileAction } from './file_action'
import type { UserInfo } from './user_info'

/**
 * FileActionData
 */
export interface FileActionData {
  /** 操作基础信息 */
  info?: FileAction
  /** 操作者信息 */
  actor_info?: UserInfo
}

/**
 * FileActionData Schema
 */
export const FileActionDataSchema: SchemaDefinition = {
  properties: {
    info: {
      $ref: 'FileAction',
      description: '操作基础信息',
      label: '操作基础信息',
    },
    actor_info: {
      $ref: 'UserInfo',
      description: '操作者信息',
      label: '操作者信息',
    },
  },
  type: 'object',
}
